import { computed, makeObservable, observable, reaction } from 'mobx';
import { find, get } from 'lodash';

import RootStore from './RootStore';

export default class PermissionStore {
  rootStore: typeof RootStore;
  @observable permissions = [];
  @observable isReady = false;

  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;

    reaction(
      () => this.rootStore.stationStore.currentStation,
      currentStation => {
        this.permissions = get(currentStation, 'permissions', []);
        this.isReady = true;
      },
    );
  }

  isAuth = permissionName => {
    return computed(() => {
      return !!find(this.permissions, { name: permissionName });
    }).get();
  };

  isAuthForStation = (permissionName: string, stationId: string): boolean => {
    const station = this.rootStore.stationStore.stations.find(station => station.id === stationId);
    const permissions = get(station, 'permissions', []);
    return !!find(permissions, { name: permissionName });
  };

  isAuthForAnyStation = (permissionName: string): boolean => {
    for (const station of this.rootStore.stationStore.stations) {
      const permissions = get(station, 'permissions', []);
      if (find(permissions, { name: permissionName })) {
        return true;
      }
    }
    return false;
  };
}
